export { default } from './SubmittingSpinner';